import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const ProspectsListView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/ProspectsListView.vue')
const CustomersListView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/CustomersListView.vue')
const ProvidersListView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/ProvidersListView.vue')
const SubcontractorsListView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/SubcontractorsListView.vue')
const CustomersItemView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/CustomersItemView/CustomersItemView.vue')
const ContactsListView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/ContactsListView.vue')
const ContactsItemView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/ContactsItemView/ContactsItemView.vue')
const CustomerStatisticsView: DynamicImport = () => import(/* webpackChunkName: "customers" */ '../views/CustomerStatisticsView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    path: '/contacts/prospect',
    name: 'contacts-prospects-list',
    component: ProspectsListView,
    meta: {
      title: i18n.t('customers.prospect.listTitle'),
      appModule: 'customers-prospects',
      userPermission: ['prospect', 1],
      buttons: [
        {
          label: i18n.t('customers.prospect.addLabel'),
          userPermission: ['prospect', 2],
          modal: {
            key: 'prospect-form',
            attributes: {
              withRedirection: true
            }
          }
        }
      ]
    }
  },
  {
    path: '/contacts/customer',
    name: 'contacts-customers-list',
    component: CustomersListView,
    meta: {
      title: i18n.t('customers.customer.listTitle'),
      userPermission: ['customer', 1],
      buttons: [
        {
          label: i18n.t('customers.customer.addLabel'),
          userPermission: ['customer', 2],
          modal: {
            key: 'customer-form',
            attributes: {
              withRedirection: true
            }
          }
        }
      ]
    }
  },
  {
    path: '/contacts/provider',
    name: 'contacts-providers-list',
    component: ProvidersListView,
    meta: {
      title: i18n.t('customers.provider.listTitle'),
      userPermission: ['provider', 1],
      buttons: [
        {
          label: i18n.t('customers.provider.addLabel'),
          userPermission: ['provider', 2],
          modal: {
            key: 'provider-form',
            attributes: {
              withRedirection: true
            }
          }
        }
      ]
    }
  },
  {
    path: '/contacts/subcontractor',
    name: 'contacts-subcontractors-list',
    component: SubcontractorsListView,
    meta: {
      title: i18n.t('customers.subcontractor.listTitle'),
      userPermission: ['subcontractor', 1],
      appModule: 'customers-subcontractors',
      buttons: [
        {
          label: i18n.t('customers.subcontractor.addLabel'),
          userPermission: ['subcontractor', 2],
          modal: {
            key: 'subcontractor-form',
            attributes: {
              withRedirection: true
            }
          }
        }
      ]
    }
  },
  {
    path: '/contacts/:type(customer|prospect|provider|subcontractor)/:id',
    name: 'contacts-customer-item',
    component: CustomersItemView,
    meta: {
      pageHeader: false,
      title: (customer: KwixeoCustomers.Customer) => customer.name,
      appClass: { 'contact-page-item': true }
    }
  },
  {
    path: '/contacts/contacts',
    name: 'contacts-contacts-list',
    component: ContactsListView,
    meta: {
      title: i18n.t('customers.contact.listTitle'),
      buttons: [
        {
          label: i18n.t('customers.contact.addLabel'),
          userPermission: ['contact', 1],
          modal: {
            key: 'contact-form',
            attributes: {
              withRedirection: true
            }
          }
        }
      ]
    }
  },
  {
    path: '/contacts/contacts/:id',
    name: 'contacts-contact-item',
    component: ContactsItemView,
    meta: {
      pageHeader: false,
      appClass: { 'contact-page-item': true }
    }
  },
  {
    path: '/contacts/statistics',
    name: 'contacts-statistics',
    component: CustomerStatisticsView,
    meta: {
      title: 'Chiffre d\'affaires par client'
    }
  }
])

export default routes
